import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import { message, Select, Modal } from 'antd'
import moment from 'moment'

import { Text, Tag } from '../../Reusable/Text'
import { StyledExtLink, StyledLink } from '../../Reusable/Link'
import { Image } from '../../Reusable/Image'
import { Flex, FlexColumn, CardContainer } from '../../Reusable/Container'
import PageHeader from '../../Reusable/PageHeader'
import { ErrorAlert } from '../../Reusable/Alert'
import { Button, TextButton, ImageButton } from '../../Reusable/Button'
import HighYieldCalculator from '../Reusable/HighYieldCalculator'

import { addDataToStore, SAVE_DATA, BNK_SAVE_DATA } from '../../../Actions/actions'
import { toNumberStr, getBPAccountsWithAccess, toCurrency } from '../../../Utils/util'
import { apiPOSTReq } from '../../../Utils/api'
import environment from '../../../environment'
import ModalClose from '../../../Images/modal-close.png'
import Diamond from '../../../Images/hya-diamond.png'
import Bulb from '../../../Images/hya-bulb.png'
import Earn from '../../../Images/hya-earn.png'
import Lock from '../../../Images/hya-lock.png'
import HYASuccess from '../../../Images/hya-success.svg'

const { Option } = Select

export const GradientText = styled.span`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    background: var(--Gradients-Aion-Gradient, 
        linear-gradient(111deg, var(--Purple-Accent-Purple---100, #8740F6) -29.15%, 
        var(--Primary-Blue-Primary-Blue---100, #19F) 78.47%, 
        var(--Primary-Blue-Primary-Blue---100, #19F) 100.52%)
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`;

class Index extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showSuccessResult: false,
            isComplete: false,
        }
    }

    componentDidMount() {
        const { theme, bankingStore } = this.props
        const { AllRecipients } = bankingStore
        console.log("fetchCounterparties: AllRecipients", AllRecipients)
        this.setState({ loading: false, recipients: AllRecipients })
        this.getInterestRateInfo()

        if (this.props.store.hyaData) this.setState({ hyaData: this.props.store.hyaData })
        else this.getInterestRateInfo()
    }

    getInterestRateInfo = () => {
        const { transferAmount } = this.state
        const { store } = this.props
        const { UserInfo } = store || {}

        const paymentAmt = toNumberStr(transferAmount)

        var body = {
            "FromDate": moment().format('YYYY-MM-DD'),
            "InterestRateType": "InterestPayout",
            "AccountNumber": "XXXX",
            "AccountType": "CHECKINGYIELD",
        }

        this.setState({ loading: true })
        console.log("HYA getInterestRateInfo", body)
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getInterestRateInfo`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp
                if (data.result) {
                    console.log("HYA getInterestRateInfo", resp)

                    const hyaData = {
                        hyaAPY: data.rateAPY,
                        fdicLink: data.fdicLink,
                        fdicAPY: data.fdicAPY,
                        fdicRate: data.fdicRate,
                        fdicEffectiveDate: data.fdicEffectiveDate,
                    }

                    this.setState({ hyaData })
                    this.props.dispatch(addDataToStore(SAVE_DATA, { hyaData }))
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA getInterestRateInfo", error, err, resp)
                ErrorAlert({ description: error.message })
            } finally {
                this.setState({ loading: false })
            }
        })
    }

    createAccount = () => {
        const body = {
            "accountTitle": "High Yield Account",
            "accountNickName": "High Yield Account",
            "accountType": "CHECKINGYIELD",
        }

        this.setState({ showSuccessResult: true })
        apiPOSTReq(`${environment.bbBaseUrl}/bb/createAccount`, { "BankProvider": environment.bankProvider.crb }, body, (err, resp) => {
            try {
                const data = resp;
                console.log("HYA createAccount", data)
                if (data.result) {
                    this.setState({ showSuccessResult: true, newAccount: data?.account }, () => {
                        setTimeout(() => {
                            this.getAccounts()
                        }, 5000);
                    })
                    if (data.responseMessage != null && data.responseMessage != "Success") {
                        ErrorAlert({ description: data.responseMessage });
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR HYA createAccount", error, err, resp);
                ErrorAlert({ description: error.message })
            }
        })
    }

    getAccounts = () => {
        const { newAccount } = this.state
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getAccounts`, { "BankProvider": environment.bankProvider.crb }, null, (err, resp) => {
            try {
                console.log("/bb/getAccounts", err, resp)
                const data = resp
                if (data.result) {
                    if (err) throw new Error(err)
                    var accounts = data.bbaccounts

                    console.log("/bb/getAccounts", accounts)

                    this.props.dispatch(addDataToStore(BNK_SAVE_DATA, { BBAccounts: accounts }))
                    var Accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: true })
                    Accounts = Accounts || []

                    this.setState({ isComplete: true })
                    setTimeout(() => {
                        this.props.history.replace({
                            pathname: '/banking/accounts',
                            state: { accountNumber: newAccount?.accountNumber }
                        })
                    }, 2000);
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getAccounts", error, err, resp)
            }
        })
    }

    render() {
        const { hyaData, showCalculator, showSuccessResult, submitLoading, isComplete } = this.state
        const { theme } = this.props
        const { fdicAPY, fdicLink, fdicEffectiveDate, fdicRate } = hyaData || {}

        return (
            <FlexColumn className='main-padding' grow start fullHeight>
                <PageHeader
                    back
                    titleText="High Yield Account"
                />

                <CardContainer padding='48px' margin='0 0 24px' grow shadow>
                    {
                        showSuccessResult ?
                            <FlexColumn center fullHeight gap='24px'>
                                {/* Circle loader with conditional "load-complete" class */}
                                <div className={`circle-loader ${isComplete ? "load-complete" : ""}`}>
                                    {/* Checkmark only visible when loading is complete */}
                                    <div className={`checkmark ${isComplete ? "draw" : ""}`} />
                                </div>

                                {
                                    isComplete ?
                                        <FlexColumn start center style={{ marginBottom: 120 }}>
                                            <Text size="20px" weight='600' margin="0 0 12px">Account created</Text>
                                            <Text margin="0 0 0">Your High Yield Account is now open! Start saving now by depositing funds.</Text>
                                        </FlexColumn>
                                        :
                                        <FlexColumn start center style={{ marginBottom: 120 }}>
                                            <Text size="20px" weight='600' margin="0 0 12px">Opening your account...</Text>
                                            <Text margin="0 0 0">Your new account is almost ready—hang tight!</Text>
                                        </FlexColumn>
                                }
                            </FlexColumn>
                            :
                            <FlexColumn start centerH fullHeight gap='24px' style={{ paddingTop: 12 }}>
                                <Image src={Diamond} height="56px" width="56px" />
                                <Text size="24px" weight="700" color="#000">
                                    Smart savings start here.
                                </Text>

                                <Flex wrap>
                                    <Text size="16px" color="#8181A0">
                                        Maximize your earnings with{" "}
                                    </Text>

                                    <Text size="16px" color='#8181A0' margin="0 4px">{hyaData?.hyaAPY}% APY<sup style={{ color: "#8740F6" }}>1</sup>{" "}</Text>

                                    <Text size="16px" color="#8181A0">—several times the national average of <StyledExtLink color='#8181A0' target="_blank" href={fdicLink} style={{ textDecoration: "underline" }}>{hyaData?.fdicAPY}%</StyledExtLink></Text>
                                        {/* % APY<sup style={{ color: "#8740F6" }}>2</sup></Text> */}
                                </Flex>

                                <FlexColumn center gap="16px" style={{ marginTop: 10, padding: 24, borderRadius: 16, background: '#F7F7F9', width: 876 }}>
                                    <GradientText>${toCurrency((hyaData?.hyaAPY / 100) * 1000000, 0, 0)} earnings on $1,000,000</GradientText>

                                    <Text size="16px" color="#8181A0" center height="24px">
                                        By clicking on “Open account” you are accepting{" "}
                                        <StyledExtLink color='#8181A0' target="_blank" href="https://www.aionfi.com/legal" style={{ textDecoration: "underline" }}>Aion’s Terms & Conditions</StyledExtLink>
                                        <br />
                                        for applying for a new High Yield Account
                                    </Text>

                                    <Button solid primary text="Open account" onClick={this.createAccount} loading={submitLoading} />

                                    <Button text='See how much you can earn' background='transparent' onClick={() => this.setState({ showCalculator: true })} />
                                </FlexColumn>

                                {/* <Text margin="80px 0 0" size="20px" weight="600" color="#000">
                                    What you get
                                </Text> */}

                                <Flex start centerH gap="48px" style={{ marginTop: 18 }}>
                                    <FlexColumn centerH gap="16px" style={{ width: '276px', textAlign: 'center' }}>
                                        <Image src={Lock} width="48px" height="48px" alt="Easy access icon" margin="0 0 12px" />
                                        <Text size="18px" weight="700" color={this.props.theme.colors.secondary}>
                                            Easy access
                                        </Text>
                                        <Text center height="24px" color={this.props.theme.colors.secondary}>
                                            Unlock funds when you need it. Instantly move it to another Aion account within seconds.
                                        </Text>
                                    </FlexColumn>

                                    <FlexColumn centerH gap="16px" style={{ width: '276px', textAlign: 'center' }}>
                                        <Image src={Bulb} width="48px" height="48px" alt="Always on icon" margin="0 0 12px" />
                                        <Text size="18px" weight="700" color={this.props.theme.colors.secondary}>
                                            Always on
                                        </Text>
                                        <Text center height="24px" color={this.props.theme.colors.secondary}>
                                            Earn interest on funds deposited in this<br />account. No additional fees or minimum<br />balances.
                                        </Text>
                                    </FlexColumn>

                                    <FlexColumn centerH gap="16px" style={{ width: '276px', textAlign: 'center' }}>
                                        <Image src={Earn} width="48px" height="48px" alt="Earn daily icon" margin="0 0 12px" />
                                        <Text size="18px" weight="700" color={this.props.theme.colors.secondary}>
                                            Grow effortlessly
                                        </Text>
                                        <Text center height="24px" color={this.props.theme.colors.secondary}>
                                            Earn daily on your money, with interest<br />paid out automatically before the 10th of<br />the following month.
                                        </Text>
                                    </FlexColumn>
                                </Flex>

                                <FlexColumn start gap="8px" center>
                                    <Text size="14px" color="#8181A0">
                                        <sup style={{ color: "#8740F6" }}>1</sup> Rates subject to change. Refer to{" "}
                                        <StyledExtLink color='#8181A0' target="_blank" href="https://www.aionfi.com/interest-earned-on-aion-high-yield-business-accounts" style={{ textDecoration: "underline" }}>Terms of Interest Accrual</StyledExtLink>
                                        .
                                    </Text>

                                    {/* <Text size="14px" color="#8181A0">
                                        <sup style={{ color: theme.colors.primary3 }}>2</sup> Calculated based on the national average rate on interest checking accounts {" "}
                                        <StyledExtLink color='#8181A0' target="_blank" href={fdicLink} style={{ textDecoration: "underline" }}>published by FDIC as of {moment(fdicEffectiveDate).format('MM/DD/YY')}</StyledExtLink>
                                        .
                                    </Text> */}
                                </FlexColumn>
                            </FlexColumn>
                    }
                </CardContainer>

                <Modal
                    visible={showCalculator}
                    footer={null}
                    closable={true}
                    width={924}
                    destroyOnClose={true}
                    bodyStyle={{ padding: 0 }}
                    onCancel={() => this.setState({ showCalculator: false })}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <HighYieldCalculator hyaData={hyaData} />
                </Modal>
            </FlexColumn>
        )
    }

    handleOnChange = (event) => {
        const target = event.target
        this.saveUserInput(target.id || target.name, target.value)
    }

    twoFAValidated = () => {
        this.props.dispatch(addDataToStore(SAVE_DATA, { "TwoFAForTransfersValidated": true }))
        this.loadNext()
    }
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(Index)))